// extracted by mini-css-extract-plugin
module.exports = {"btn":"J_p z_tD z_tt h_fp h_fD h_fs h_hf","full":"J_wH h_dp h_dz"};